/**
  * Js Search for top page
*/
const tagButton = () => {
  const buttonItems = document.querySelectorAll('.js-tagButton');
  const resultItems = document.querySelectorAll('.js-tagButton-result');
  const searchField = document.querySelector('.jsSearchResults');

  if ( buttonItems.length > 0 && resultItems.length > 0 ) {
    buttonItems.forEach(buttonElement => {
      buttonElement.addEventListener( 'click', function () {
        if (buttonElement.classList.contains( 'active' )) {
          buttonItems.forEach(element => {
            element.classList.remove('active');
            element.classList.remove('inactive');
          });
          resultItems.forEach(element => {
            element.classList.remove( 'active' );
          });
        } else {
          buttonItems.forEach(element => {
            element.classList.add('inactive');
            element.classList.remove('active');
          });
          buttonElement.classList.remove('inactive');
          buttonElement.classList.add('active');

          resultItems.forEach(resultElement => {
            if ( resultElement.getAttribute( 'name' ) == buttonElement.querySelector('button')?.getAttribute('name') ) {
              resultElement.classList.add( 'active' );
            } else {
              resultElement.classList.remove( 'active' );
            }
          });
        }

        if (searchField) {
          searchField.classList.remove('active');
        }
      });
    });
  }
};

export default tagButton;
